import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, BaseViewConfigService, ProductAssortmentParentService, ProductInlineSearchCardComponent, ProductInlineSearchListConfigService, SelectedCustomerService } from 'gung-standard';
import { environment } from 'projects/tylo/src/environments/environment';

@Component({
  selector: 'tylo-inline-search-card',
  templateUrl: './tylo-inline-search-card.component.html',
  styleUrls: ['./tylo-inline-search-card.component.css']
})
export class TyloInlineSearchCardComponent extends ProductInlineSearchCardComponent implements OnInit {
  finnishCustomerWithD = false;
  projectName = environment.projectName;
  constructor(
    protected router: Router,
    protected productInlineSearchListConfigService: ProductInlineSearchListConfigService,
    protected authService: AuthService,
    protected baseViewConfigService: BaseViewConfigService,
    protected productAssortmentParentService: ProductAssortmentParentService,
    protected selectedCustomerService: SelectedCustomerService
  ) {
    super(router, productInlineSearchListConfigService, baseViewConfigService, productAssortmentParentService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.selectedCustomerService.getSelectedCustomer().subscribe(customer => {
      if (customer.id.toLowerCase().startsWith('d')) {
        this.finnishCustomerWithD = true;
      }
    });
  }
}
